import accountSettingsModule from '../accountSettingsModule';

const displayNameConstants = {
  changeDisplayNameModal: {
    templateUrl: 'change-display-name-modal',
    controllerName: 'changeDisplayNameController'
  },
  eventstreamParams: {
    changeDisplayNameEvent: 'changeDisplayname',
    successCtx: 'success',
    cancelCtx: 'cancel'
  }
};

accountSettingsModule.constant('displayNameConstants', displayNameConstants);

export default displayNameConstants;
